import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [formData, setFormData] = useState({
    login_name: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/users/login`, formData);
      
      if (response.data && response.data.success) {
        // Store token in localStorage
        const token = response.data.token || 'dummy-token'; // Fallback if token is in a different field
        localStorage.setItem('token', token);
        
        console.log('Login successful:', response.data);
        navigate('/dashboard'); // Redirect to dashboard after login
      }
    } catch (err) {
      console.error('Login error:', err);
      setError(err.response?.data?.message || 'Login failed. Redirecting to home...');
      
      // Redirect to home page on failure as requested
      setTimeout(() => {
        navigate('/');
      }, 2000); // Wait 2 seconds to show the error message before redirecting
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="d-flex align-items-center justify-content-center vh-100 pt-5" style={{ backgroundColor: 'var(--color-surface)' }}>
      <Container>
        <Row className="justify-content-center">
          <Col md={6} lg={5}>
            <Card className="border-0 shadow-lg" style={{ borderRadius: '12px' }}>
              <div className="p-4 p-md-5">
                <div className="text-center mb-4">
                  <h2 className="fw-bold" style={{ color: 'var(--color-text)', fontFamily: 'var(--font-serif)' }}>Admin Login</h2>
                  <p className="text-muted" style={{ color: 'var(--color-text-muted) !important' }}>Please enter your credentials to access the admin portal.</p>
                </div>

                {error && <Alert variant="danger">{error}</Alert>}
                
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-4" controlId="formBasicEmail">
                    <Form.Label className="fw-bold" style={{ color: 'var(--color-text)' }}>Login Name</Form.Label>
                    <Form.Control 
                      type="text" 
                      name="login_name"
                      value={formData.login_name}
                      onChange={handleChange}
                      placeholder="Enter admin login name" 
                      className="py-2" 
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-4" controlId="formBasicPassword">
                    <Form.Label className="fw-bold" style={{ color: 'var(--color-text)' }}>Password</Form.Label>
                    <Form.Control 
                      type="password" 
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      placeholder="Enter password" 
                      className="py-2" 
                      required
                    />
                  </Form.Group>

                  <Button 
                    variant="primary" 
                    type="submit" 
                    disabled={loading}
                    className="w-100 py-3 fw-bold mt-2" 
                    style={{ backgroundColor: 'var(--color-accent)', borderColor: 'var(--color-accent)', letterSpacing: '1px', textTransform: 'uppercase' }}
                  >
                    {loading ? 'Signing In...' : 'Sign In'}
                  </Button>
                </Form>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Login;
